const propTypes = require('./prop-types');
const { renderStyleTag } = require('./common');

const Style = (props) => renderStyleTag(props);

Style.propTypes = propTypes;

Style.Style = Style;

module.exports = Style;
